<template>
	<div class="align-list">
		<div
			v-for="(item, $itemIndex) in items"
			:key="$itemIndex"
			:class="[{
				active: item === alignCurrent,
				 'tooltip tooltip--centered dark': item === TEXT_ALIGN.UNDER.VALUE || item === TEXT_ALIGN.STRIKE.VALUE
			}, isDisabledClassname]"
			class="align-item"
			@click="chooseAlign($itemIndex, item)"
		>
			<i :class="TEXT_ALIGN[item.toUpperCase()].ICON"></i>
			<div v-if="item === TEXT_ALIGN.UNDER.VALUE || item === TEXT_ALIGN.STRIKE.VALUE" class="tooltip__item bottom">Available soon</div>
		</div>
	</div>
</template>

<script>
import {TEXT_ALIGN} from '@/models/TEXT_ALIGN';
import {computed} from 'vue';

export default {
	props: {
		items: {
			type: Array,
			default: () => Object.values(TEXT_ALIGN).map(item => item.VALUE)
		},
		alignCurrent: {
			type: String
		},
		disabled: {
			type: Boolean,
			default: false,
		}
	},
	setup(props, {emit}) {
		
		function chooseAlign(index, item){
			if(item === TEXT_ALIGN.UNDER.VALUE || item === TEXT_ALIGN.STRIKE.VALUE) return;
			if(props.disabled) return;
			emit('update:alignCurrent', props.items[index])
		}
		
		const isDisabledClassname = computed(() => props.disabled ? "disabled" : "");
		
		return {
			chooseAlign,
			TEXT_ALIGN,
			isDisabledClassname
		}
	}
}
</script>

<style lang="scss">
@use "@/scss/sections/editor/elements/align/align-list";
@use "@/scss/sections/editor/elements/align/align-item";
</style>
